<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="UserViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{workflowAttribute.name}}</p>
                <div v-for="type in inputTypes">
                  <p v-if="type['.key'] == workflowAttribute.type">{{type.name}}</p>
                </div>
                <p>{{workflowAttribute.active == true ? 'Active': 'Inactive'}}</p>
                <br>
                <button v-on:click="edit" v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99" type="button" class="btn  btn-default form-group">Edit</button>
              </div>
            </div>
            <!--Editing-->
            <div class="UserEditing col-md-5" v-show="isEditing">
              <form-text ref="name" label="Name" name="name" v-model="workflowAttributeEdit.name" validation="required"></form-text>
              <form-select ref="type" label = "Type" name="type" v-model="workflowAttributeEdit.type" :options="inputTypes" validation="required"></form-select>
              <br>
              <form-checkbox label="Active" name="active" v-model="workflowAttributeEdit.active"></form-checkbox>
              <br>
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn btn-success">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import ActiveFormCheckbox from '../../elements/Form/ActiveFormCheckbox'
import FormTextMask from '../../elements/Form/FormTextMask'
import FormSelect from '../../elements/Form/FormSelect'
import database from '../../webmaster/Database/database'
import store from '../../webmaster/Store/vuex'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'workflowattributedetail',
  components:{
    'form-text':FormText,
    'form-text-mask':FormTextMask,
    'form-checkbox':ActiveFormCheckbox,
    'form-select':FormSelect
  },
  data () {
    return {
      workflowAttribute:{},
      workflowAttributeEdit:{},
      isEditing: false,
      inputTypes: [{'name': "Number", '.key': "number"}, {'name': "Text", '.key': "text"}, {'name': "True/False", '.key': "bool"}],
      org: store.state.usermain,
    }
  },
  created:function(){
    this.fetchWorkflowAttribute()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    fetchWorkflowAttribute: function(){
      this.$bindAsObject('workflowAttribute', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/workflow_attributes/' + this.$route.params.id), null, function(){
        this.workflowAttributeEdit = Object.assign({}, this.workflowAttributeEdit, this.workflowAttribute);
      });
    },
    submitEdit: function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var curOrgId = self.$store.state.usermain.curOrg.id
        var updates = {};
        updates['/orgs/' + curOrgId + '/workflow_attributes/' + this.$route.params.id + '/name'] = self.workflowAttributeEdit.name;
        updates['/orgs/' + curOrgId + '/workflow_attributes/' + this.$route.params.id + '/type'] = self.workflowAttributeEdit.type;
        updates['/orgs/' + curOrgId + '/workflow_attributes/' + this.$route.params.id + '/active'] = self.workflowAttributeEdit.active;
        database.getDb().ref().update(updates, function(){
          self.isEditing = false
        });
      }, () => {});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// WorkflowAttributeDetail.vue?126a679e